<template>
  <weui-msg type="warn" :primary="true" title="您修改的是一系列重复课程" desc="请作出以下进一步选择">
    <weui-button type="primary" @click="saveCurrent">仅修改本节课</weui-button>
    <weui-button type="default" @click="saveRemaining">同时修改本系列余下课程</weui-button>
    <weui-button type="default" @click="$router.go(-1)">返回上一页</weui-button>
  </weui-msg>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import weui from 'weui.js';
import { WeuiButton, WeuiMsg } from '@/components/weui';
import dtos from '@/dtos/course';

import { ROUTE_CALENDAR } from '@/router/names';
import { PATCH_COURSE, PATCH_CURRENT_COURSE } from '@/store/course/types';

const { mapState, mapActions } = createNamespacedHelpers('course');

export default {
    data() {
        return {
            id: 0,
        };
    },
    computed: {
        ...mapState({
            draft: state => state.draft,
        }),
    },
    created() {
        const { id } = this.$route.params;
        this.id = Number.parseInt(id, 10);

        if (!dtos.periodic(this.draft)) {
            this.$router.go(-1);
        }
    },
    methods: {
        ...mapActions({
            patchCourse: PATCH_COURSE,
            patchCurrentCourse: PATCH_CURRENT_COURSE,
        }),
        saveCurrent() {
            this.patchCurrentCourse()
                .then(() => {
                    weui.toast('保存成功');
                    this.$router.push({
                        name: ROUTE_CALENDAR,
                        query: {
                            date: this.draft.date,
                        },
                    });
                });
        },
        saveRemaining() {
            this.patchCourse()
                .then(() => {
                    weui.toast('保存成功');
                    this.$router.push({
                        name: ROUTE_CALENDAR,
                        query: {
                            date: this.draft.date,
                        },
                    });
                });
        },
    },
    components: {
        WeuiButton,
        WeuiMsg,
    },
};
</script>



// WEBPACK FOOTER //
// src/containers/course/Editing.vue